<template>
  <div>
    <a-card>
      <div :class="advanced ? 'search' : null">
        <a-form layout="horizontal">
          <div :class="advanced ? null : 'fold'">
            <a-row>
              <a-col :md="6" :sm="24">
                <a-form-item
                  label="离校批次"
                  :labelCol="{ span: 5 }"
                  :wrapperCol="{ span: 18, offset: 1 }"
                >
                  <a-select
                    placeholder="全部"
                    v-model="params.batchId"
                    @change="initData"
                  >
                    <a-select-option
                      v-for="item in batchList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item
                  label="学院"
                  :labelCol="{ span: 5 }"
                  :wrapperCol="{ span: 18, offset: 1 }"
                >
                  <a-select
                    placeholder="全部"
                    :allowClear="true"
                    v-model="params.studentCollege"
                    @change="loadSpeciality"
                  >
                    <a-select-option
                      v-for="item in collegeList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item
                  label="专业"
                  :labelCol="{ span: 5 }"
                  :wrapperCol="{ span: 18, offset: 1 }"
                >
                  <a-select
                    placeholder="全部"
                    :allowClear="true"
                    v-model="params.studentSpeciality"
                  >
                    <a-select-option
                      v-for="item in specialityList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <!-- <a-col :md="6" :sm="24">
                <a-form-item
                  label="学历"
                  :labelCol="{ span: 5 }"
                  :wrapperCol="{ span: 18, offset: 1 }"
                >
                  <a-select
                    placeholder="全部"
                    :allowClear="true"
                    v-model="params.studentEducation"
                  >
                    <a-select-option
                      v-for="item in studentEducationList"
                      :value="item.code"
                      :key="item.code"
                      >{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col> -->
              <a-col :md="6" :sm="24">
                <a-form-item
                  label="毕业类型"
                  :labelCol="{ span: 5 }"
                  :wrapperCol="{ span: 18, offset: 1 }"
                >
                  <a-select
                    placeholder="全部"
                    :allowClear="true"
                    v-model="params.graduateType"
                  >
                    <a-select-option
                      v-for="item in graduateTypeList"
                      :value="item.code"
                      :key="item.code"
                      >{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item
                  label="状态"
                  :labelCol="{ span: 5 }"
                  :wrapperCol="{ span: 18, offset: 1 }"
                >
                  <a-select
                    placeholder="全部"
                    :allowClear="true"
                    style="width: 50%"
                    mode="multiple"
                    v-model="params.itemName"
                  >
                    <a-select-option
                      v-for="item in itemList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}
                    </a-select-option>
                  </a-select>
                  <a-select
                    placeholder="全部"
                    :allowClear="true"
                    style="width: 50%"
                    v-model="params.itemStatus"
                  >
                    <a-select-option
                      v-for="item in statusList"
                      :value="item.code"
                      :key="item.code"
                      >{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item
                  label="离校进度"
                  :labelCol="{ span: 5 }"
                  :wrapperCol="{ span: 18, offset: 1 }"
                >
                  <a-select
                    placeholder="全部"
                    :allowClear="true"
                    v-model="params.leavingStatus"
                  >
                    <a-select-option
                      v-for="item in leavingStatusList"
                      :value="item.code"
                      :key="item.code"
                      >{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item
                  label="姓名/学号"
                  :labelCol="{ span: 5 }"
                  :wrapperCol="{ span: 18, offset: 1 }"
                >
                  <a-input
                    placeholder="请输入"
                    :allowClear="true"
                    v-model="params.studentName"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <span style="float: right; margin-top: 3px">
            <a-button type="primary" @click="search">查询</a-button>
            <a-button style="margin-left: 8px" @click="reset">重置</a-button>
            <a @click="toggleAdvanced" style="margin-left: 8px">
              {{ advanced ? "收起" : "展开" }}
              <a-icon :type="advanced ? 'up' : 'down'" />
            </a>
          </span>
        </a-form>
      </div>
      <a-divider></a-divider>
      <div>
        <div
          class="btn-group"
          style="display: flex; justify-content: space-between"
        >
          <div>
            <a-button
              type="primary"
              :disabled="selectedRowKeys.length < 1"
              v-auth:permission="`HANDLER`"
              @click="batchPassVisible = true"
              >批量办理
            </a-button>
            <a-button
              style="margin-left: 8px"
              :disabled="!selectedRowKeys.length"
              v-auth:permission="`MSG`"
              @click="batchSendMsgVisible = true"
              >批量消息</a-button
            >
            <a-button
              type="primary"
              style="margin-left: 8px"
              v-auth:permission="`IMPORT-BATCH`"
              @click="onImport"
              >导入办理
            </a-button>
          </div>
          <div>
            <a-button
              type="default"
              icon="setting"
              @click="dynamicColumnsVisible = true"
              >字段设置</a-button
            >
            <a-button
              type="default"
              style="margin-left: 8px"
              icon="cloud-download"
              v-auth:permission="'EXPORT'"
              @click="downloadExcel"
              >导出</a-button
            >
          </div>
        </div>
        <a-table
          :columns="dynamicColumns"
          :data-source="dataSource"
          :loading="loading"
          :scroll="{ x: 1300 }"
          :row-selection="rowSelection"
          :pagination="pagination"
          rowKey="student_code"
        >
          <template slot="img" slot-scope="text">
            <a>{{ text }}</a>
          </template>

          <span slot="action" slot-scope="row">
            <a-button
              type="link"
              size="small"
              v-auth:permission="'HANDLER'"
              @click="onPass(row)"
              >办理</a-button
            >
            <!-- <a-button
              type="link"
              size="small"
              v-auth:permission="'DEFER-HANDLER'"
              @click="onPostpone(row)"
              >暂缓办理</a-button
            > -->
            <a-button
              type="link"
              size="small"
              v-auth:permission="'MSG'"
              @click="onSendMsg(row)"
              >消息</a-button
            >
            <a-button
              type="link"
              size="small"
              v-auth:permission="'EDIT'"
              @click="onShowEdit(row)"
              >修改</a-button
            >
          </span>

          <div slot="pass" slot-scope="{}">
            <a-button
              size="small"
              @click="passVisible = true"
              style="color: #8a1106"
              >通过</a-button
            >
          </div>
        </a-table>
      </div>
    </a-card>

    <!--  批量导入弹窗  -->
    <a-modal
      title="上传"
      v-model="importVisible"
      @ok="submitUploadStudentLeaving"
    >
      <ol>
        <li>
          <p>
            下载模板，并按照模板中的使用说明填写信息，<span style="color: red">
              请勿更改表结构（如删除某行）</span
            >
          </p>
          <p><a @click="downloadTemplateFile">下载《离校管理导入模板》</a></p>
        </li>
        <li>
          <p>请选择填写完成的excel 文档</p>
          <a-form-model
            ref="uploadExcelRuleForm"
            :model="currentFrom"
            :rules="uploadExcelRules"
          >
            <a-form-model-item
              :labelCol="{ span: 0 }"
              :wrapperCol="{ span: 24 }"
              prop="fileName"
            >
              <c-upload
                name="file"
                :multiple="false"
                :action="uploadFileUri"
                acceptType="excel"
                @change="handleChange"
              >
                <div v-if="currentFrom.fileName">
                  <a-icon type="file-excel" />
                  <a v-text="currentFrom.fileName"></a>
                </div>
                <a-button v-else>
                  <a-icon :type="loadingFile ? 'loading' : 'plus'" />选择文件
                </a-button>
              </c-upload>
            </a-form-model-item>
          </a-form-model>
          <p>请上传格式为xls或xlsx的文件，最大支持30M</p>
        </li>
      </ol>
    </a-modal>

    <!--  推送消息弹窗  -->
    <a-modal
      v-model="sendMsgVisible"
      @ok="submitSendMsg"
      class="send-msg-modal"
      okText="发送"
    >
      <template #title>
        <a-tabs>
          <a-tab-pane key="1" tab="模板消息">
            <p>
              *请选择要发送催办的事项，推送消息内容为模板内容，<a
                @click="$router.push('/settings/msg-template')"
                href="javascript:;"
                >编辑模板内容</a
              >
            </p>
            <p>
              <a-table
                :columns="itemStatusColumns"
                :dataSource="itemStatusInfoList"
                :pagination="false"
                rowKey="itemId"
                :row-selection="itemStatusRowSelection"
              >
                <span slot="status" slot-scope="code">
                  {{ statusMapper[code] }}
                </span>
              </a-table>
            </p>
          </a-tab-pane>
          <a-tab-pane key="2" tab="自定义消息">
            <a-textarea
              v-model="sendMsgFrom.msg"
              placeholder="请输入自定义消息内容"
              :auto-size="{ minRows: 18, maxRows: 30 }"
            />
          </a-tab-pane>
        </a-tabs>
      </template>
    </a-modal>

    <!--  办理业务弹窗  -->
    <a-modal
      title="请选择要通过的离校事项"
      v-model="passVisible"
    >
        <a-table
          :columns="itemStatusColumns"
          :dataSource="itemStatusInfoList"
          :pagination="false"
          rowKey="itemId"
          :row-selection="itemStatusRowSelection"
        >
          <span slot="status" slot-scope="code">
            {{ statusMapper[code] }}
          </span>
        </a-table>
      <template slot="footer">
        <a-button key="back" @click="passVisible=false"> 取消 </a-button>
         <a-button
          key="defer"
          v-auth:permission="'DEFER-HANDLER'"
          @click="submitSelectedItemIdsPostpone"
        >
          暂缓办理
        </a-button>
        <a-button
          key="submit"
          type="primary"
          v-auth:permission="'HANDLER'"
          @click="submitSelectedItemIdsPass"
        >
          办理
        </a-button>
      </template>
    </a-modal>

    <!--  暂缓办理  -->
    <a-modal
      title="请选择要暂缓办理的离校事项"
      v-model="postponeVisible"
      @ok="submitSelectedItemIdsPostpone"
    >

        <a-table
          :columns="itemStatusColumns"
          :dataSource="itemStatusInfoList"
          :pagination="false"
          rowKey="itemId"
          :row-selection="itemStatusRowSelection"
        >
          <span slot="status" slot-scope="code">
            {{ statusMapper[code] }}
          </span>
        </a-table>
    </a-modal>

    <!--  批量推送消息弹窗  -->
    <a-modal
      v-model="batchSendMsgVisible"
      @ok="submitSendMsg"
      class="send-msg-modal"
      okText="发送"
    >
      <template #title>
        <a-tabs>
          <a-tab-pane key="1" tab="模板消息">
            <p>
              *请选择要发送催办的事项，推送消息内容为模板内容，<a
                @click="$router.push('/settings/msg-template')"
                href="javascript:;"
                >编辑模板内容</a
              >
            </p>
            <p>
              <a-table
                :columns="itemStatusBatchColumns"
                :dataSource="itemStatusInfoList"
                :pagination="false"
                rowKey="itemId"
                :row-selection="{
                  selectedRowKeys: selectedItemRowIds,
                  onChange: onItemTableRowSelectionChange,
                  getCheckboxProps: getBatchCheckboxProps,
                }"
              >
              </a-table>
            </p>
          </a-tab-pane>
          <a-tab-pane key="2" tab="自定义消息">
            <a-textarea
              v-model="sendMsgFrom.msg"
              placeholder="请输入自定义消息内容"
              :auto-size="{ minRows: 18, maxRows: 30 }"
            />
          </a-tab-pane>
        </a-tabs>
      </template>
    </a-modal>

    <!--  批量办理业务弹窗  -->
    <a-modal
      title="请选择要通过的离校事项"
      v-model="batchPassVisible"
    >
      <a-table
        :columns="itemStatusBatchColumns"
        :dataSource="itemStatusInfoList"
        :pagination="false"
        rowKey="itemId"
        :row-selection="{
          selectedRowKeys: selectedItemRowIds,
          onChange: onItemTableRowSelectionChange,
          getCheckboxProps: getBatchCheckboxProps,
        }"
      >
      </a-table>
      <template slot="footer">
        <a-button key="back" @click="batchPassVisible=false"> 取消 </a-button>
        <a-button
            key="defer"
            v-auth:permission="'DEFER-HANDLER'"
            @click="submitSelectedItemIdsPostpone"
        >
          暂缓办理
        </a-button>
        <a-button
            key="submit"
            type="primary"
            v-auth:permission="'HANDLER'"
            @click="submitSelectedItemIdsPass"
        >
          办理
        </a-button>
      </template>
    </a-modal>

    <!--  修改弹窗  -->
    <a-modal
      title="请选择要通过的离校事项"
      v-model="editVisible"
      @ok="submitEnableItemIdsPass"
    >
      <div class="user-info">
        <a-list :grid="{ gutter: 16, column: 2 }">
          <a-list-item>姓名: {{ activeRow.student_name }}</a-list-item>
          <a-list-item>学院: {{ activeRow.student_college_name }}</a-list-item>
          <a-list-item>班级: {{ activeRow.student_class }}</a-list-item>
          <!-- <a-list-item>学历: {{ activeRow.studentEducation }}</a-list-item> -->
          <a-list-item>学历: {{ activeRow.student_graduate_type }}</a-list-item>
        </a-list>
      </div>
      <div>
        <ul class="radio-list">
          <li v-for="item in itemStatusInfoList" :key="item.itemId">
            <span v-text="item.itemName"></span>
            <span v-text="statusMapper[item.statusClone]"></span>
            <!-- <span
              v-text="
                item.status == '-1'
                  ? '无需办理'
                  : item.status == '0'
                  ? '已办理'
                  : '未办理'
              "
            ></span> -->
            <!-- <a-radio-group name="radioGroup" v-model="item.status"
              :disabled="currentUserItemCanHandlerMapper[item.itemId] == 1"> -->
            <!-- 修改根据isHandle（后台管理设置的是否可手动修改   0可修改   1不可修改）判断是否可勾选 -->
            <a-radio-group
              name="radioGroup"
              v-model="item.status"
              :disabled="currentUserItemCanHandlerMapper[item.itemId] == 1"
            >
              <a-radio :value="0"> 已办理 </a-radio>
              <a-radio :value="1"> 未办理 </a-radio>
            </a-radio-group>
          </li>
        </ul>
      </div>
    </a-modal>

    <!--  字段设置弹窗  -->
    <a-modal
      title="字段设置"
      :visible="dynamicColumnsVisible"
      @ok="dynamicColumnsVisible = false"
      @cancel="dynamicColumnsVisible = false"
    >
      <ul class="cols">
        <template v-for="(col, index) in columns">
          <li :key="col.key" v-if="index < columns.length - 1">
            <a-checkbox v-model="col.isShow">{{ col.title }}</a-checkbox>
          </li>
        </template>
      </ul>
    </a-modal>
  </div>
</template>

<script>
import uploadFileUri from "@/services/uploadFileUri";
import {
  downloadStudentLeavingExcel,
  uploadStudentLeavingExcel,
  findAll,
  getColumns,
  sendMsg,
  passStudentItem,
  stopStudentItem,
  recallStudentItem,
  listStudentItemStatus,
  downloadStudentItemExcel,
  editStudentItemStatus,
} from "@/services/schoolLeaving";
import { getTreeByCode } from "@/services/dict";
import { listGraduationBatch } from "@/services/graduationList";
import { listCollege, listMajorDic } from "@/services/organization";
import { listItem } from "@/services/event";
import { getCurrentUserItems } from "@/services/authority";

const uploadExcelRules = {
  fileName: [{ required: true, message: "请选择文件", trigger: "change" }],
};

const columns = [
  {
    title: "操作",
    key: "action",
    align: "center",
    width: 200,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];

const leavingStatusList = [
  {
    code: "1",
    name: "完成",
  },
  {
    code: "0",
    name: "未完成",
  },
];

const dataSource = [];
const itemStatusInfoList = [
  // {
  //   itemId: 121212,
  //   orgName: "财务部",
  //   itemName: "检查缴费欠费情况",
  //   status: "0",
  // },
  // { itemId: 2, orgName: "图书馆", itemName: "归还图书", status: "1" },
  // { itemId: 3, orgName: "图书馆", itemName: "提交电子版学位论文", status: "0" },
  // {
  //   itemId: 4,
  //   orgName: "学工处",
  //   itemName: "签订校园地贷款还款协议",
  //   status: "1",
  // },
  // {
  //   itemId: 5,
  //   orgName: "科技处",
  //   itemName: "签订离校科技成果协议书",
  //   status: "1",
  // },
  // { itemId: 6, orgName: "组织部", itemName: "党组织关系转移", status: "1" },
  // { itemId: 7, orgName: "团委", itemName: "团组织关系转移", status: "1" },
  // { itemId: 8, orgName: "保卫处", itemName: "户籍迁移、发放", status: "1" },
  // { itemId: 9, orgName: "学生公寓", itemName: "退宿离校", status: "1" },
];
const itemStatusColumns = [
  {
    title: "部门",
    dataIndex: "orgName",
  },
  {
    title: "事项",
    dataIndex: "itemName",
  },
  {
    title: "状态",
    dataIndex: "status",
    width: 100,
    scopedSlots: {
      customRender: "status",
    },
  },
];
const itemStatusBatchColumns = [
  {
    title: "部门",
    dataIndex: "orgName",
  },
  {
    title: "事项",
    dataIndex: "itemName",
  },
];

const params = {
  page: 1,
  limit: 10,
  batchId: undefined,
  studentCollege: undefined,
  studentSpeciality: undefined,
  studentEducation: undefined,
  graduateType: undefined,
  itemName: [],
  itemStatus: undefined,
  studentName: undefined,
  studentCode: undefined,
  leavingStatus: undefined,
};
const batchList = [];
const collegeList = [];
const specialityList = [];
const educationList = [];
const statusList = [];
const graduateTypeList = [];
const studentEducationList = [];
const itemList = [];

export default {
  name: "SchoolLeavingManagement",
  data() {
    return {
      uploadExcelRules,
      params: Object.assign({}, params),
      batchList,
      collegeList,
      specialityList,
      educationList,
      statusList,
      graduateTypeList,
      studentEducationList,
      leavingStatusList,
      itemList,
      noPassStatusCode: 1,
      pagination: {
        pageSize: 10,
        showTotal: (total) => `共${total}条`,
        current: 1,
        total: 0,
        onChange: (current) => this.onPageChange(current),
      },
      selectedRowKeys: [],
      selectedStudentIds: [],
      loading: false,
      loadingFile: false,
      sendMsgFrom: {
        studentCodes: [],
        itemIds: [],
        msg: undefined,
      },
      currentFrom: { fileName: undefined },
      activeRow: {},
      dynamicColumnsVisible: false,
      advanced: true,
      importVisible: false, //批量导入弹窗
      sendMsgVisible: false, // 推送消息弹窗
      passVisible: false, //确认通过提醒
      editVisible: false, //修改弹窗
      batchSendMsgVisible: false, // 推送消息弹窗
      batchPassVisible: false, //确认通过提醒
      postponeVisible: false, //暂缓办理弹窗
      itemStatusInfoList: itemStatusInfoList,
      itemStatusBatchColumns,
      currentUserItemCanHandlerMapper: {},
      statusMapper: {},
      uploadFileUri,
      itemStatusColumns,
      columns,
      dataSource: dataSource,
      selectedItemRowIds: [],
      isSelectedAllRow: false,
    };
  },
  methods: {
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    async onPass(item) {
      this.selectedRowKeys = [];
      this.isSelectedAllRow = false;
      this.activeRow = item;
      this.selectedStudentIds = [item.student_code];
      this.itemStatusInfoList = [];
      await this.loadItem(item.id);
      this.passVisible = true;
    },
    async onPostpone(item) {
      this.selectedRowKeys = [];
      this.isSelectedAllRow = false;
      this.activeRow = item;
      this.selectedStudentIds = [item.student_code];
      this.itemStatusInfoList = [];
      await this.loadItem(item.id);
      this.postponeVisible = true;
    },
    async onSendMsg(item) {
      this.selectedRowKeys = [];
      this.isSelectedAllRow = false;
      this.activeRow = item;
      this.selectedStudentIds = [item.student_code];
      this.itemStatusInfoList = [];
      await this.loadItem(item.id);
      this.sendMsgVisible = true;
    },
    async onShowEdit(item) {
      this.selectedRowKeys = [];
      this.isSelectedAllRow = false;
      this.activeRow = item;
      this.selectedStudentIds = [item.student_code];
      this.itemStatusInfoList = [];
      await this.loadItem(item.id);
      this.editVisible = true;
    },
    handleChange(info) {
      console.log(info);
      if (info.file.status !== "uploading") {
        this.loadingFile = true;
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.loadingFile = false;
        this.currentFrom.filepath = info.file.response.data.filePath;
        this.currentFrom.fileName = info.file.name;
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 文件上传失败.`);
      }
    },
    onTableRowSelectionChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedStudentIds = selectedRowKeys;
      this.isSelectedAllRow = false;
    },
    onItemTableRowSelectionChange(selectedRowKeys) {
      this.selectedItemRowIds = selectedRowKeys;
    },
    getBatchCheckboxProps(record) {
      return {
        props: {
          disabled: this.currentUserItemCanHandlerMapper[record.itemId] == 1, // Column configuration not to be checked
          name: record.name,
        },
      };
    },
    //批量通过特定配置
    getOneCheckboxProps(record) {
      return {
        props: {
          disabled:
            this.currentUserItemCanHandlerMapper[record.itemId] == 1 ||
            record.status == "-1", // Column configuration not to be checked
          // disabled: record.status == '-1' || record.isHandle == '1', // Column configuration not to be checked
          name: record.name,
        },
      };
    },
    onPageChange(page) {
      this.params.page = page;
      this.loadData();
    },
    async loadSpeciality(collegeId) {
      this.specialityList = await listMajorDic(collegeId);
    },
    search() {
      this.onPageChange(1);
    },
    reset() {
      this.params = Object.assign({}, params, { batchId: this.params.batchId });
      this.search();
    },
    async loadData() {
      this.loading = true;
      this.selectedRowKeys = [];
      this.dataSource = [];
      let params = Object.assign({}, this.params, {
        itemName: this.params.itemName.join(","),
      });
      // let params = Object.assign({}, this.params);
      const d = await findAll(params);
      this.loading = false;
      this.dataSource = d.records;
      this.pagination.current = d.current;
      this.pagination.total = d.total;
    },
    onImport() {
      this.currentFrom.fileName = undefined;
      this.currentFrom.filepath = undefined;
      this.importVisible = true;
    },
    async submitUploadStudentLeaving() {
      this.$refs.uploadExcelRuleForm.validate(async (valid) => {
        if (valid) {
          this.currentFrom.batchId = this.params.batchId;
          let msgContent = await uploadStudentLeavingExcel(this.currentFrom);
          if (msgContent.msg) return this.$message.error(msgContent.msg);
          this.$message.success("上传成功");
          this.importVisible = false;
          this.search();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async submitSendMsg() {
      await sendMsg({
        type: this.isSelectedAllRow ? "all" : "",
        studentCode: this.isSelectedAllRow
          ? undefined
          : this.selectedStudentIds.join(","),
        itemIds: this.selectedItemRowIds.join(","),
        msg: this.sendMsgFrom.msg,
        batchId: this.params.batchId,
        params: this.isSelectedAllRow ? this.params : {},
      });
      this.sendMsgVisible = false;
      this.batchSendMsgVisible = false;
      this.$message.success("消息发送成功");
      this.sendMsgFrom = {
        studentCodes: [],
        itemIds: [],
        msg: undefined,
        batchId: this.params.batchId,
      };
      this.selectedRowKeys = [];
      this.selectedStudentIds = [];
      this.selectedItemRowIds = [];
    },
    async submitSelectedItemIdsPass() {
      this.$confirm({
        title: "提醒",
        content: "确认通过?",
        onOk: () => {
          this.submitPass0(this.selectedItemRowIds, this.selectedStudentIds);
        },
      });
    },
    async submitEnableItemIdsPass() {
      this.$confirm({
        title: "提醒",
        content: "确认通过?",
        onOk: () => {
          this.editStatus(
            this.params.batchId,
            this.selectedStudentIds,
            this.itemStatusInfoList
          );
        },
      });
    },
    async submitSelectedItemIdsPostpone() {
      this.$confirm({
        title: "提醒",
        content: "确认暂缓办理?",
        onOk: async () => {
          await stopStudentItem({
            type: this.isSelectedAllRow ? "all" : "",
            studentIds: this.isSelectedAllRow
              ? undefined
              : this.selectedStudentIds,
            itemIds: this.selectedItemRowIds.join(","),
            batchId: this.params.batchId,
            params: this.isSelectedAllRow ? this.params : {},
          });
          // this.selectedStudentIds = [];
          // this.selectedItemRowIds = [];
          // this.postponeVisible = false;
          this.selectedRowKeys = [];
          this.selectedStudentIds = [];
          this.selectedItemRowIds = [];
          this.$message.success("操作成功");
          this.passVisible = false;
          this.batchPassVisible = false;
          this.loadData();
        },
      });
    },
    async editStatus(batchId, studentIds, items) {
      let itemIds = items.map((o) => ({ itemId: o.itemId, status: o.status }));
      await editStudentItemStatus({ batchId, studentIds, itemIds });
      this.$message.success("操作成功");
      this.editVisible = false;
      this.loadData();
    },
    async submitPass0(passItemIds, selectedStudentIds, isNoPassHandler) {
      let selected = new Set(passItemIds);
      let difference = this.itemStatusInfoList
        .map((o) => o.itemId)
        .filter((x) => !selected.has(x));

      // let map = new Map();
      // this.dataSource.forEach((item) => {
      //   if (this.selectedStudentIds.includes(item.id)) {
      //     map.set(item.id, item);
      //   }
      // });
      await passStudentItem({
        type: this.isSelectedAllRow ? "all" : "",
        studentIds: this.isSelectedAllRow ? undefined : selectedStudentIds,
        itemIds: Array.from(selected).join(","),
        batchId: this.params.batchId,
      });
      if (isNoPassHandler) {
        await recallStudentItem({
          studentIds: this.selectedStudentIds.join(","),
          itemIds: Array.from(difference).join(","),
          batchId: this.params.batchId,
        });
      }
      this.selectedStudentIds = [];
      this.selectedRowKeys = [];
      this.selectedItemRowIds = [];
      this.$message.success("操作成功");
      this.passVisible = false;
      this.batchPassVisible = false;
      this.loadData();
    },
    async loadItem(studentId) {
      this.itemStatusInfoList = (
        await listStudentItemStatus({ studentId })
      ).map((o) => {
        o.statusClone = o.status;
        return o;
      });
    },
    //确认批量导入
    importOk() {
      console.info("确认批量导入");
    },
    downloadTemplateFile() {
      downloadStudentLeavingExcel({ batchId: this.params.batchId });
    },
    downloadExcel() {
      let params = Object.assign({}, this.params, {
        itemName: this.params.itemName.join(","),
      });
      // let params = Object.assign({}, this.params);
      downloadStudentItemExcel(params);
    },
    async initData() {
      let has = new Set();
      let columns0 = (await getColumns())
        .filter((t) => (has.has(t.key) ? false : has.add(t.key)))
        .map((o) => {
          let obj = Object.assign({ width: 150 }, o, { dataIndex: o.key });
          obj.customRender = (text, row) => {
            if (o.isFormat == 1) {
              return this.statusMapper[text];
            }
            if (o.isFormat == 2) {
              return row.hjqyxx && JSON.parse(row.hjqyxx)[o.key]
                ? JSON.parse(row.hjqyxx)[o.key]
                : "-";
            } else {
              return text;
            }
          };
          return obj;
        });
      for (let i = 0; i < 3; i++) {
        columns0[i].fixed = "left";
      }
      columns0 = [...columns0, ...columns];
      columns0.forEach((col) => (col.isShow = true));
      this.columns = columns0;

      this.batchList = await listGraduationBatch();
      if (this.batchList.length > 0 && !this.params.batchId) {
        this.params.batchId = this.batchList[0].id;
      }
      this.collegeList = await listCollege();
      this.itemList = await listItem();
      this.statusList = await getTreeByCode("BLZT");
      this.graduateTypeList = await getTreeByCode("BYLX");
      // this.studentEducationList = await getTreeByCode('XL');
      this.statusMapper = {};
      this.statusList.forEach((o) => {
        this.statusMapper[o.code] = o.name;
      });
      let d = await getCurrentUserItems();
      let currentUserItemCanHandlerMapper = {};
      d.item.forEach((o) => {
        currentUserItemCanHandlerMapper[o.value] = o.is_handle;
      });
      this.currentUserItemCanHandlerMapper = currentUserItemCanHandlerMapper;
      console.log(
        "currentUserItemCanHandlerMapper",
        this.currentUserItemCanHandlerMapper
      );
      await this.loadData();
      if (this.dataSource.length) {
        this.loadItem(this.dataSource[0].id);
      }
    },
  },
  computed: {
    dynamicColumns() {
      return this.columns.filter((o) => o.isShow == undefined || o.isShow);
    },
    itemStatusRowSelection() {
      return {
        selectedRowKeys: this.selectedItemRowIds,
        onChange: this.onItemTableRowSelectionChange,
        getCheckboxProps: this.getOneCheckboxProps,
      };
    },
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        selectedRowKeys,
        onChange: this.onTableRowSelectionChange,
        hideDefaultSelections: true,
        selections: [
          {
            key: "current-data",
            text: "当前数据全选",
            onSelect: changableRowKeys => {
              this.isSelectedAllRow = false;
              this.selectedRowKeys = changableRowKeys;
              this.selectedStudentIds = changableRowKeys;
            }
          },
          {
            key: "all-data",
            text: "全部全选",
            onSelect: changableRowKeys => {
              this.isSelectedAllRow = true;
              this.selectedRowKeys = changableRowKeys;
            }
          }
        ],
        onSelection: this.onSelection
      };
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 64px;
}

.fold {
  width: calc(100% - 216px);
  display: inline-block;
}

.operator {
  // margin-bottom: 18px;
}

@media screen and (max-width: 900px) {
  .fold {
    width: 100%;
  }
}

.cols {
  list-style: none;

  > li {
    padding: 5px;
  }
}

.radio-list {
  list-style: none;
  padding-inline-start: 0;

  > li {
    display: grid;
    grid-template-columns: 2fr 1fr 2fr;
    padding: 15px;
  }
}

.user-info {
  padding: 0 15px;
}
</style>
<style>
.send-msg-modal .ant-modal-body {
  display: none;
}

.edit-model-table .ant-form-item {
  margin-bottom: 0;
}

.edit-model-table .ant-table-thead {
  display: none;
}

/* .edit-model-table .ant-table-thead>tr>th,
.edit-model-table .ant-table-tbody>tr>td {
  padding: 5px 10px;
  overflow-wrap: break-word;
} */
</style>